// 获取热门推荐
import axios from "axios";
let BASE_URL = "";
if (process.env.NODE_ENV == "development") {
  BASE_URL = `/api`;
} else if (process.env.NODE_ENV == "production") {
  // Get the user's protocol (http: or https:)
  // 动态获取当前页面的协议和域名
  const protocol = window.location.protocol; // http: 或 https:
  const hostname = window.location.hostname; // 如: www.jxdinfo.com
  BASE_URL = `${protocol}//${hostname}/jxdinfo`;
}
axios.defaults.baseURL = BASE_URL;
export { axios as request };
export function getContentInfo(params) {
  return new Promise((resolve, reject) => {
    axios
      .postForm("/contentInfo_channelId.jspx", params)
      .then((res) => {
        console.log(res);
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
export function topLevelArticleList(params) {
  return new Promise((resolve, reject) => {
    axios
      .postForm("/contentInfo_channelId.jspx", params)
      .then((res) => {
        if (res.status == 200) {
          if (res.data.content.length === 0) {
            return topLevelArticleList(params);
          }
          resolve(res.data.content);
        } else {
          console.log(res.msg);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//获取热门标签
export function getTipList(params) {
  return new Promise((resolve, reject) => {
    axios
      .postForm("/contentTagByCount.jspx", params)
      .then((res) => {
        if (res.status == 200) {
          if (res.data.content.length === 0) {
            return getTipList(params);
          }
          resolve(res.data.content);
        } else {
          reject(res.msg);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}
//获取验证码
export function getPhoneCode(params) {
  return new Promise((resolve, reject) => {
    axios
      .postForm("/sendPhoneCode.jspx", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
export function saveForm(params) {
  return new Promise((resolve, reject) => {
    axios
      .postForm("/saveForm.jspx", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
/* 查询企业名称 */
export function getCompanyName(params) {
  return new Promise((resolve, reject) => {
    axios
      .postForm("/queryCompanyName.jspx", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
